import Globe01 from "../../../../../../assets/Globe01";
import Typography from "../../../../../../common/Typography";
import PhoneCall01 from "../../../../../../assets/PhoneCall01";
import MarkerPin03 from "../../../../../../assets/MarkerPin03";
import { getFullImageUrl } from "../../../../../../../utils/constants/constants";

const StoreDetails = ({ data, storeNameTxtColor }) => {
  return (
    <div className="store-details">
      <div
        className="store-logo"
        style={{
          backgroundColor: data.text_color,
        }}
      >
        {data?.logo ? (
          <img
            alt="store-logo"
            title={data.storeName}
            src={getFullImageUrl(data?.logo)}
          />
        ) : (
          <Typography
            size="text-xs"
            weight="medium"
            style={{ color: data?.theme_color }}
          >
            {data.storeName}
          </Typography>
        )}
      </div>
      <div className="store-profile">
        <Typography
          size="text-md"
          weight="medium"
          style={{ color: storeNameTxtColor }}
        >
          {data.storeName}
        </Typography>
        <div className="social-links">
          {data.sources?.length > 0 &&
            data.sources.map((src, i) => {
              const platform = platforms.find(
                (platform) => platform.value === src.source
              );
              return (
                <a
                  key={i}
                  target="_blank"
                  rel="noreferrer"
                  className="link-logo"
                  href={
                    src.source === "phone_number"
                      ? `tel:${src.link}`
                      : src.link.includes("http")
                      ? src.link
                      : `http://${src.link}`
                  }
                >
                  {platform?.image ? (
                    <img alt={src.source} src={platform?.image} />
                  ) : (
                    platform?.icon
                  )}
                </a>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const platforms = [
  {
    value: "",
    image: "",
    sourceLink: "",
    label: "Remove this action button",
  },
  {
    sourceLink: "",
    value: "website",
    label: "Website",
    icon: <Globe01 />,
  },
  {
    sourceLink: "",
    value: "zomato",
    label: "Zomato",
    image: "/assets/images/qr/edit/theme/zomato.svg",
  },
  {
    sourceLink: "",
    value: "google_maps",
    label: "Google Maps",
    icon: <MarkerPin03 />,
  },
  {
    sourceLink: "",
    value: "justdial",
    label: "JustDial",
    image: "/assets/images/qr/edit/theme/just_dial.svg",
  },
  {
    sourceLink: "",
    value: "tripadvisor",
    label: "Trip Advisor",
    image: "/assets/images/qr/edit/theme/tripadvisor.svg",
  },
  {
    sourceLink: "",
    value: "phone_number",
    label: "Phone Number",
    icon: <PhoneCall01 />,
  },
  {
    sourceLink: "",
    value: "instagram",
    label: "Instagram",
    image: "/assets/icons/social-icons/insta-colored.svg",
  },
  {
    sourceLink: "",
    value: "facebook",
    label: "Facebook",
    image: "/assets/images/feedback/reviews/social/fb.svg",
  },
];

export default StoreDetails;
